import type { ReactNode } from 'react';
import { Card } from '../../ui';

interface ChartPanelProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
  actions?: ReactNode;
  height?: number;
}

export function ChartPanel({ title, subtitle, children, actions, height = 300 }: ChartPanelProps) {
  return (
    <Card padding="md">
      <header className="flex items-start justify-between gap-4 mb-3">
        <div>
          <h3 className="font-serif text-base text-ink-primary">{title}</h3>
          {subtitle && <p className="text-xs text-ink-tertiary mt-0.5">{subtitle}</p>}
        </div>
        {actions}
      </header>
      <div style={{ width: '100%', height }}>{children}</div>
    </Card>
  );
}
